import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, of } from "rxjs";
import { FeatureToggleResponseDto } from "../dto/response/feature-toggle-response-dto.interface";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"})
export class FeatureToggleService {
  constructor(private _httpClient: HttpClient) {}

  getFeatureToggles(): Observable<FeatureToggleResponseDto> {
    return this._httpClient
      .get<FeatureToggleResponseDto>(
        `${environment.backend}/feature-toggles/all`
      )
      .pipe(
        catchError(() => {
          return of({
            data: [
              {
                id: "37a1eb69-c0b7-4eb3-a976-f9e6231d1068",
                name: "maintenance",
                description: "Toggle para colocar o site inteiro em manutenção",
                active: false,
                createdAt: "2025-07-20T03:23:06.236Z",
                updatedAt: "2025-07-20T03:23:06.236Z"},
              {
                id: "37a1eb69-c0b7-4eb3-a976-f9e6231d1068",
                name: "donate",
                description: "Toggle para colocar o site inteiro em manutenção",
                active: true,
                createdAt: "2025-07-20T03:23:06.236Z",
                updatedAt: "2025-07-20T03:23:06.236Z"}],
            pagination: {
              total: 1,
              page: 1,
              pageSize: 10,
              totalPage: 1}});
        })
      );
  }
}
